// src/hooks/useNavigateWithContext.js
import { useCallback } from 'react';
import { flushSync } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useOrder } from '../contexts/OrderContext';
import { useAppointment } from '../contexts/AppointmentContext';

export const useNavigateWithContext = () => {
  const navigate = useNavigate();
  const { setOrder } = useOrder();
  const { setAppointment, refreshAppointments } = useAppointment();

  return useCallback(async (id, target="/", objectType = "order") => {
      if (objectType === 'order') {
        let orderLoaded = false;
        flushSync(() => {
          orderLoaded = setOrder(id);
        });
        if (!orderLoaded) {
          toast.error('Order details could not be loaded. Please refresh orders and try again.');
          return false;
        }
        navigate(target, {replace: true});
        return true;
      } else if (objectType === 'appointment') {
        const refreshedAppointments = await refreshAppointments();
        let appointmentLoaded = false;
        flushSync(() => {
          appointmentLoaded = setAppointment(id, refreshedAppointments);
        });
        if (!appointmentLoaded) {
          toast.error('Appointment details could not be loaded. Please refresh appointments and try again.');
          return false;
        }
        navigate(target, {replace: true});
        return true;
      }
    },
    [setOrder, setAppointment, refreshAppointments, navigate]
  );
};
